import { API_URL, MERCADO_PAGO_API_URL, STRAPI_API_URL, VIACEP_URL } from '../../constants/config'
import i18n from '../../services/i18n'

import makeRequest, { Res, ResponseSuccess } from './make-request'

export const mercadoPagoRequest = makeRequest(MERCADO_PAGO_API_URL, { includeLocale: false })

// VIACEP request for Brazil address
export const viacepRequest = makeRequest(VIACEP_URL, { includeLocale: false })

// Inject our i18n service here, so i18n itself can import makeRequest without circular dependencies
export const apiRequest = makeRequest(API_URL, {
  includeLocale: true,
  i18n,
  sendTracingHeaders: true,
})
export const strapiRequest = makeRequest(STRAPI_API_URL, { includeLocale: true, i18n })

export const isSuccess = <T>(res: Res<T>): res is ResponseSuccess<T> => res.error === null
